import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import "./tools-page-header.css";

class ToolsPageHeader extends Component {
	render() {
		const { title, subtitle, badges, lead, facts, actions, nav, onBack, backLabel = "Back", compact } = this.props;

		return (
			<header className={clsx("tools-page-header", compact && "tools-page-header--compact", nav && "tools-page-header--with-nav")}>
				<div className="tools-page-header__row">
					{onBack && (
						<button type="button" className="tk-back-button" onClick={onBack} aria-label={backLabel} title={backLabel}>
							<Icon.ArrowLeft size={16} />
						</button>
					)}
					{lead}
					<div className="tools-page-header__text">
						<div className="tools-page-header__title-row">
							<h1 className="tools-page-header__title">{title}</h1>
							{badges}
						</div>
						{subtitle && <p className="tools-page-header__subtitle">{subtitle}</p>}
						{facts && <div className="tools-page-header__facts">{facts}</div>}
					</div>
					{actions && <div className="tools-page-header__actions">{actions}</div>}
				</div>
				{nav && <div className="tools-page-header__nav">{nav}</div>}
			</header>
		);
	}
}

export default ToolsPageHeader;
